<!-- src/views/HomePage.vue -->
<template>
  <div class="c-text-column" style="    position: relative;top: -90px;">

    <div class="  px-container c-mb-20" style="background-color: #7e83e0;color: #fff;">
      <div class="c-text-between c-text-both" style="padding: 8px;">
        <div>系统映像 v5.10 现已推出</div>
        <a style="border: 2px solid #fff;padding: 4px 20px;cursor: pointer;border-radius: 5px;" class="newBack"
          @click="$router.push('/products/franka-research-3/#system-image')">了解新功能</a>
      </div>
    </div>
    <div class="c-text-between px-container c-flex-wrap" style="margin: 80px 0;">
      <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
        <span class="c-mb-10">人工智能与机器人研究的标杆平台</span>
        <h1 style="font-size: 40px;font-family: 'Montserrat', sans-serif;text-align: left;">Franka Research 3</h1>
        <span class="c-mt-10 c-mb-10 c-text-left text-indent">
          Franka Research
          3是专为人工智能与机器人研究打造的全球标杆级力敏机器人系统。该系统不仅提供开箱即用的便捷功能，更开放底层控制与学习接口，全面赋能科研工作。
        </span>
        <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10">
          <router-link to="/contact" class="buttonSite">立刻咨询</router-link>
        </div>
      </div>

      <div class="display-width c-text-align">
        <div style="aspect-ratio:  480/253;">
          <div style="width: 100%;" class="c-text-both c-pos-relative" v-show="!iframeValue">
            <img src="@/assets/images/productsPage/FR3_4K_DCI-thumb-1.png" style="width: 100%;aspect-ratio: 480/253;" />
            <div class="bigPlayButton" @click="iframeValue = true">
              <svg viewBox="0 0 32 32">
                <path
                  d="M6.484 4.094l20.75 11.225c0.226 0.121 0.41 0.427 0.41 0.683s-0.184 0.563-0.41 0.683l-20.75 11.222c-0.095 0.051-0.26 0.093-0.367 0.093-0.427 0-0.774-0.346-0.774-0.773v-22.451c0-0.428 0.347-0.774 0.774-0.774 0.108 0 0.272 0.042 0.367 0.093z">
                </path>
              </svg>
            </div>
          </div>
          <iframe src="https://player.bilibili.com/player.html?bvid=BV1AnNFzqEon" v-if="iframeValue" width="100%"
            height="100%" frameborder="0" scrolling="no" allowfullscreen="true"></iframe>
        </div>
      </div>
    </div>
    <div style="background: #eff1f3;  " class=" c-pdt-20">
      <div class="line-with-text px-container ">
        <hr class="divider">
        <span class="line-text">WHY FRANKA RESEARCH 3
        </span>
        <hr class="divider">
      </div>

      <div class="c-text-between px-container  c-flex-wrap c-font-14">
        <div class="action-width c-text-column c-mb-60">
          <div class="c-mb-5" style="overflow: hidden;">
            <!-- 4b260ce4e6024b3d8814757eb1e1580.jpg -->
            <img src="@/assets/images/productsPage/_Frank Robotics4386_resized-1.jpg" alt="" class="image-style"
              style="height: auto; max-width: 100%;aspect-ratio: 716/450;object-fit: cover;">
          </div>
          <div class="c-text-left c-font-weight">卓越机电一体化系统</div>
          <div class="c-text-left ">Franka Research 3是德国精工制造的人机协作机器人系统，集高精度传感、顶级驱动和优化人机工效设计于一体。
          </div>
        </div>
        <div class="action-width c-text-column c-mb-60 ">
          <div class="c-mb-5" style="overflow: hidden;">
            <img src="@/assets/images/productsPage/_Frank Robotics4381_cropped_resized.jpg" class="image-style" alt=""
              style="height: auto; max-width: 100%;aspect-ratio: 716/450;object-fit: cover;">
          </div>
          <div class="c-text-left c-font-weight">媲美人手灵巧度</div>
          <div class="c-text-left ">Franka Research 3的7自由度机械臂拥有类人灵巧特性，可在狭小空间灵活避障作业，完美复现人手运动能力。
          </div>
        </div>
        <div class="action-width c-text-column c-mb-60">
          <div class="c-mb-5" style="overflow: hidden;">
            <img src="@/assets/images/productsPage/_Frank Robotics0265_resized.jpg" class="image-style" alt=""
              style=" height: auto; max-width: 100%;aspect-ratio: 716/450;object-fit: cover;">
          </div>
          <div class="c-text-left c-font-weight">高灵敏度感知</div>
          <div class="c-text-left ">Franka Research 3的高灵敏度关节扭矩传感器与快速控制回路可实现精准外力检测和瞬时碰撞响应，支持高级力控应用和流畅的手动引导操作。
          </div>
        </div>
        <div class="action-width c-text-column c-mb-60 ">
          <div class="c-mb-5" style="overflow: hidden;">
            <img src="@/assets/images/productsPage/_Frank Robotics0564resized.jpg" class="image-style" alt=""
              style=" height: auto; max-width: 100%;aspect-ratio: 716/450;object-fit: cover;">
          </div>
          <div class="c-text-left c-font-weight">灵活多样的控制接口</div>
          <div class="c-text-left ">Franka Research 3提供从快速任务配置的直观编程界面到深度研究所需的底层关节控制等全方位控制方案，满足从初学者到资深研究者的不同需求层次。
          </div>
        </div>
        <div class="action-width c-text-column c-mb-60">
          <div class="c-mb-5" style="overflow: hidden;">
            <img src="@/assets/images/productsPage/_Franka Robotics 20241741 (1)resized.jpg" class="image-style" alt=""
              style=" height: auto; max-width: 100%;aspect-ratio: 716/450;object-fit: cover;">
          </div>
          <div class="c-text-left c-font-weight">先进运动控制系统</div>
          <div class="c-text-left ">Franka Research 3 配备1kHz高频运动控制及底层高精度传感器数据接口，专为运动控制研究和特定复杂行为开发而设计，其性能远超普通机器人系统。
          </div>
        </div>
        <div class="action-width c-text-column c-mb-60">
          <div class="c-mb-5" style="overflow: hidden;">
            <img src="@/assets/images/productsPage/_Frank Robotics0014_resized.jpg" class="image-style" alt=""
              style=" height: auto; max-width: 100%;aspect-ratio: 716/450;object-fit: cover;">
          </div>
          <div class="c-text-left c-font-weight">开放协作平台</div>
          <div class="c-text-left ">加入全球顶尖机器人研究者的行列，Franka Research 3可无缝兼容ROS 2、MATLAB等主流开源框架，助力您快速复现、推进并共享前沿研究成果。
          </div>
        </div>
      </div>
    </div>
    <div style="margin-bottom: 80px;margin-top: 80px;"
      class="c-text-both c-text-justify-start  px-container c-flex-wrap">
      <div class="c-text-column flex-width c-mb-40">
        <img src="@/assets/images/productsPage/Group 1788.png" alt=""
          style="    max-height: 100%;max-width: 100%;height: 65px; object-fit: contain;">
        <div class="c-mt-5 c-mb-20">有效载荷</div>
        <div style="color: #4266a1;">3 kg</div>
      </div>
      <div class="c-text-column flex-width c-mb-40">
        <img src="@/assets/images/productsPage/Group 1756.png" alt=""
          style="    max-height: 100%;max-width: 100%;height: 65px; object-fit: contain;">
        <div class="c-mt-5 c-mb-20">工作半径</div>
        <div style="color: #4266a1;">855 mm</div>
      </div>
      <div class="c-text-column flex-width c-mb-40">
        <img src="@/assets/images/productsPage/Group 1786.svg" alt=""
          style="    max-height: 100%;max-width: 100%;height: 65px; object-fit: contain;">
        <div class="c-mt-5 c-mb-20">工作空间效率</div>
        <div style="color: #4266a1;">94.5 %</div>
      </div>
      <div class="c-text-column flex-width c-mb-40">
        <img src="@/assets/images/productsPage/Group 15526.svg" alt=""
          style="    max-height: 100%;max-width: 100%;height: 65px; object-fit: contain;">
        <div class="c-mt-5 c-mb-20">位置重复精度</div>
        <div style="color: #4266a1;">± 0.1 mm</div>
      </div>
      <div class="c-text-column flex-width c-mb-40">
        <img src="@/assets/images/productsPage/Group 15525.svg" alt=""
          style="    max-height: 100%;max-width: 100%;height: 65px; object-fit: contain;">
        <div class="c-mt-5 c-mb-20">自由度</div>
        <div style="color: #4266a1;">7</div>
      </div>
      <div class="c-text-column flex-width c-mb-40">
        <img src="@/assets/images/productsPage/Group 15512.svg" alt=""
          style="    max-height: 100%;max-width: 100%;height: 65px; object-fit: contain;">
        <div class="c-mt-5 c-mb-20">集成扭矩传感器</div>
        <div style="color: #4266a1;">7</div>
      </div>
      <!-- <div class="c-text-column flex-width c-mb-40">
        <img src="@/assets/images/productsPage/Group 4.svg" alt=""
          style="    max-height: 100%;max-width: 100%;height: 65px; object-fit: contain;">
        <div class="c-mt-5 c-mb-20">认证</div>
        <div style="color: #4266a1;">ISO 10218</div>
        <div style="color: #4266a1;">ISO 13849</div>
      </div> -->
    </div>
    <div style="background: #eff1f3;   padding-bottom: 5px;" class=" c-pdt-20">
      <div class="line-with-text px-container" id="system-image">
        <hr class="divider">
        <span class="line-text">最新动态</span>
        <hr class="divider">
      </div>

      <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 120px; ">
        <div class="display-width c-text-column c-mb-60  c-pdr-40"
          style="align-items: flex-start; justify-content: center;">
          <h1>探索全新升级</h1>
          <span class="c-mt-5 c-mb-10 text-indent" style="text-align: left;">
            全新功能、扩展组件与性能优化，助您始终快人一步。FR3 及其配套软件将通过免费的空中升级（OTA）持续迭代，永不止步。
          </span>
          <span class="c-mt-5 c-mb-10 text-indent" style="text-align: left;">
            <a class="linkTag" @click="$router.push('/contact')">立即了解</a>
          </span>
          <span class="c-mt-5 c-mb-10 text-indent" style="text-align: left;">
           前往 Franka Community 查看 System Image 5.10 发布公告
          </span>
           <a href="https://www.franka-community.de/login" class="linkTag" style="margin-top: 5px;"
          target="_blank">前往Franka社区</a>
        </div>
        <div class="display-width c-text-both" style="aspect-ratio: 716/450;">
          <div class="carousel-container">
            <div class="carousel" @mouseenter="pauseCarousel" @mouseleave="resumeCarousel">
              <div class="slides-wrapper" :style="{ transform: `translateX(-${activeIndex * 100}%)` }">
                <div v-for="(img, index) in images" :key="index" class="slide">
                  <img :src="img.src" :alt="img.alt" class="carousel-img">
                </div>
              </div>

              <button class="carousel-btn prev" @click="prevSlide">
                <svg width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 15L2 8L10 1" stroke="white" stroke-width="2"></path>
                </svg>
              </button>
              <button class="carousel-btn next" @click="nextSlide">
                <svg width="11" height="16" viewBox="0 0 11 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 15L9 8L1 1" stroke="white" stroke-width="2"></path>
                </svg>
              </button>

              <div class="carousel-indicators">
                <span v-for="(img, index) in images" :key="'indicator-' + index"
                  :class="{ active: activeIndex === index }" @click="goToSlide(index)"></span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 80px;gap: 40px;">
        <div class="display-width c-text-column ">
          <div class="c-text-justify-start">
            <h3 class="c-text-left c-mr-10">加速度计数据</h3>
            <div class="c-text-align">
              <span  class="bg-chetwode-blue text-white rounded-full uppercase inline-flex items-center justify-center px-[8px] py-[3px] text-[8px] leading-[5px] lg:text-[10px] lg:leading-[8px] whitespace-nowrap">
               SYSTEM IMG v5.10</span>
            </div>
          </div>
          <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
            libfranka 现已公开来自关节安装式传感器的加速度计数据，为您提供额外的机器人状态信息，用于高级应用和监控。
          </span>

        </div>
        <div class="display-width c-text-column ">
          <div class="c-text-justify-start">
            <h3 class="c-text-left c-mr-10">DESK API</h3>
            <div class="c-text-align">
              <span  class="bg-chetwode-blue text-white rounded-full uppercase inline-flex items-center justify-center px-[8px] py-[3px] text-[8px] leading-[5px] lg:text-[10px] lg:leading-[8px] whitespace-nowrap">
                SYSTEM IMG v5.8</span>
            </div>
          </div>
          <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
            全新的 Desk API 使您能够通过编程方式管理和操作 FR3。可通过编程方式打开制动器、激活 FCI、清除安全故障等等！
          </span>
        </div>
        <div class="display-width c-text-column ">
           <div class="c-text-justify-start">
            <h3 class="c-text-left c-mr-10">扭矩校准</h3>
            <div class="c-text-align">
              <span  class="bg-chetwode-blue text-white rounded-full uppercase inline-flex items-center justify-center px-[8px] py-[3px] text-[8px] leading-[5px] lg:text-[10px] lg:leading-[8px] whitespace-nowrap">
                SYSTEM IMG v5.8</span>
            </div>
          </div>
          <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
            可在现场直接重新校准内部扭矩传感器，确保在其整个生命周期内始终保持一致的精度。
          </span>
        </div>
        <div class="display-width c-text-column ">
           <div class="c-text-justify-start">
            <h3 class="c-text-left c-mr-10">MUJOCO 支持</h3>
            <div class="c-text-align">
              <span  class="bg-chetwode-blue text-white rounded-full uppercase inline-flex items-center justify-center px-[8px] py-[3px] text-[8px] leading-[5px] lg:text-[10px] lg:leading-[8px] whitespace-nowrap">
                From the community
</span>
            </div>
          </div>
          <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
            借助 MUJOCO 提升您的仿真能力，为建模与测试提供无缝体验。
          </span>
        </div>
        <div class="display-width c-text-column "> 
           <div class="c-text-justify-start">
            <h3 class="c-text-left c-mr-10">关节空间点动</h3>
            <div class="c-text-align">
              <span  class="bg-chetwode-blue text-white rounded-full uppercase inline-flex items-center justify-center px-[8px] py-[3px] text-[8px] leading-[5px] lg:text-[10px] lg:leading-[8px] whitespace-nowrap">
                SYSTEM IMG V5.9
</span>
            </div>
          </div>
          <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
            在“测试与点动”模式下，可通过 Desk 侧边栏直接控制单个关节。利用直观、精确的关节级调节功能，对位姿进行微调。
          </span>
        </div>
        <div class="display-width c-text-column ">
          <div class="c-text-justify-start">
            <h3 class="c-text-left c-mr-10">FCI 控制增强</h3>
            <div class="c-text-align">
              <span  class="bg-chetwode-blue text-white rounded-full uppercase inline-flex items-center justify-center px-[8px] py-[3px] text-[8px] leading-[5px] lg:text-[10px] lg:leading-[8px] whitespace-nowrap">
               SYSTEM IMG V5.9
</span>
            </div>
          </div>
          <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
            FCI 现支持异步关节位置更新，并可完全访问机器人数据表级别的关节限位——从而实现更平滑、更灵活且更具柔顺性的控制工作流程。
          </span>
        </div>
      </div>

    </div>
    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">高精度运动控制</span>
      <hr class="divider">
    </div>
    <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 80px;">
      <div class="display-width c-text-column  c-pdr-40" style="align-items: flex-start; justify-content: center;">
        <h1 class="c-text-left">FRANKA控制接口（FCI）</h1>

        <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          Franka控制接口（FCI）专为需要精细控制机器人并访问实时传感器数据的研究者设计。它是运动控制研究及开发特定复杂行为的理想工具，其性能远超普通机器人系统。
        </span>

        <a href="https://frankarobotics.github.io/docs/" class="linkTag" target="_blank"> 阅读文档</a>

      </div>
      <div class="display-width c-text-both" style="aspect-ratio: 716/450;">
        <img src="@/assets/images/productsPage/Flow Graphic V3.jpg" style=" height: 100%; max-width: 100%;" />
      </div>
    </div>

    <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 80px;">
      <div class="display-width c-text-column ">
        <h1 class="c-text-left">全开放直接控制</h1>
        <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          FCI提供机器人的底层实时直接控制（无内部转换），仅通过内部监控防止自损，并开放控制回路权限，支持关节空间的位置/速度/扭矩及笛卡尔空间的位置/速度控制。
        </span>
      </div>
      <div class="display-width c-text-column ">
        <h1 class="c-text-left">数据采集</h1>
        <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          以1kHz频率采集传感器与模型中的系统状态数据，FCI还提供外力估计及深度参数分析。
        </span>
      </div>
    </div>
    <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 80px;">
      <div class="display-width c-text-column ">
        <h1 class="c-text-left">开发者社区</h1>
        <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          加入Franka Robotics开发者社区，使用C++、ROS 2或MATLAB/Simulink加速机器人研发创新。
        </span>
      </div>
      <div class="display-width c-text-column ">
        <h1 class="c-text-left">安全防护</h1>
        <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          实施自定义安全规则，确保操作人员安全防护。
        </span>
      </div>
    </div>

    <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 80px;">
      <div class="display-width c-text-both" style="aspect-ratio: 716/450;">
        <img src="@/assets/images/productsPage/_Frank Robotics0615_resized-1 (1).jpg"
          style=" height: auto; width: 100%;" />
      </div>
      <div class="display-width c-text-column  c-pdr-40" style="align-items: flex-start;">
        <h1 class="c-text-left">实时控制与ROS集成</h1>
        <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          Franka控制接口（FCI） 提供快速、底层的双向连接，直接控制机械臂与末端执行器。它实时反馈机器人状态，并支持通过以太网连接的外部工作站PC进行直接控制。通过我们的开源C++接口 libfranka，您可以以 1
          kHz
          的频率发送实时控制指令，支持以下5种接口：
        </span>
        <li class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          关节级扭矩指令（含重力与摩擦补偿）
        </li>
        <li class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          关节位置/速度指令
        </li>
        <li class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          笛卡尔位姿/速度指令
        </li>
        <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          同时，您可获取 1 kHz 的测量数据，包括：
        </span>
        <li class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          关节数据（如位置、速度及连杆侧扭矩传感器信号）
        </li>
        <li class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          外部施加扭矩与力的估计值
        </li>
        <li class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          碰撞与接触信息
        </li>
        <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          机器人模型库提供：
        </span>
        <li class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          所有关节的正运动学计算
        </li>
        <li class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          所有关节的雅可比矩阵
        </li>
        <li class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          动力学模型、惯性矩阵、科里奥利力与重力矢量
        </li>
        <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          此外，franka_ros将Franka机器人接入完整ROS 2生态系统，通过libfranka与ROS 2
          Control集成，提供机器人及末端执行器的URDF模型和精细3D网格（支持RViz可视化与Gazebo仿真），并借助MoveIt!集成简化运动规划与夹爪控制，同时提供基于ROS 2的机器人操作示例。
        </span>
      </div>
    </div>
    <div id="product-add-ons"></div>
    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">附加组件</span>
      <hr class="divider">
    </div>
    <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 60px;">
      <div class="display-width c-text-column  c-pdr-40" style="align-items: flex-start; justify-content: center;">
        <h1 class="c-text-left">适配不同应用场景的交互界面</h1>
        <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
          针对机器人研究的全领域需求，我们提供三种不同操作权限的访问级别，以满足不同技能水平的用户。
        </span>

      </div>
    </div>
    <div class="c-text-between px-container  c-flex-wrap" style="margin-bottom: 120px;">
      <div class="action-width c-text-column" style="padding: 10px;margin-bottom: 10px;">
        <div class="c-mb-5" style="overflow: hidden;">
          <img src="@/assets/images/productsPage/desk.470b822.png" alt="" class="image-style"
            style="height: auto; max-width: 100%;">
        </div>
        <div style="align-items: flex-start;text-align: left;" class=" c-text-column ">
          <h1>DESK</h1>
          <span class="c-mt-5 c-mb-5 text-indent">
            Desk让编程变得省时省力，是快速原型开发、简单人机交互研究和演示的最佳用户界面。
          </span>
          <div class="linkTag">
            <a href="https://franka.world/?redirect_after_login_to=%2Fresources" target="_blank"> 查看详细信息</a>
          </div>
        </div>
      </div>
      <div class="action-width c-text-column " style="padding: 10px;margin-bottom: 10px;">
        <div class="c-mb-5" style="overflow: hidden;">
          <img src="@/assets/images/productsPage/ride.a041de5.png" class="image-style" alt=""
            style="height: auto; max-width: 100%;">
        </div>

        <div style="align-items: flex-start;text-align: left;" class=" c-text-column ">
          <h1>RIDE </h1>
          <span class="c-mt-5 c-mb-5 text-indent" style="overflow: hidden;">
            RIDE使研究人员能够将Franka Robotics系统完全集成到实验设置中，充分利用其高性能的集成控制器。
            它也是教学入门级机器人技术的优秀工具，提供了一个用户友好的界面，便于学习和实验。
          </span>
          <div class="linkTag">
            <a href="https://franka.world/?redirect_after_login_to=%2Fresources" target="_blank"> 查看详细信息</a>
          </div>
        </div>
      </div>
      <div class="action-width c-text-column" style="padding: 10px;margin-bottom: 10px;">
        <div class="c-mb-5">
          <img src="@/assets/images/productsPage/fci.7cc017e.png" alt="" class="image-style"
            style=" height: auto; max-width: 100%;">
        </div>
        <div style="align-items: flex-start;text-align: left;" class=" c-text-column ">
          <h1>FCI </h1>
          <span class="c-mt-5 c-mb-5 text-indent">
            FCI绕过机器人的控制系统，使研究人员能够在外部实时计算机上以1 kHz的频率运行自定义控制算法。它是探索底层规划和控制方案的理想接口。
          </span>
          <div class="linkTag">
            <a href="https://franka.world/?redirect_after_login_to=%2Fresources" target="_blank"> 查看详细信息</a>
          </div>
        </div>
      </div>
    </div>
    <div class=" px-container" style="margin-bottom: 120px;">
      <table>
        <thead>
          <tr>
            <th>功能</th>
            <th>DESK</th>
            <th>RIDE</th>
            <th>FCI</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in tableData" :key="index">
            <td>{{ row.name }}</td>
            <td>
              <span v-if="row.DESK">
                <div class="c-text-both">
                  <div
                    style="display: inline-block;width: 14px;height: 14px;background: #36475a;border-radius: 50%;text-align: center;">
                  </div>
                </div>
              </span>
              <span v-else></span>
            </td>
            <td>
              <span v-if="row.RIDE">
                <div class="c-text-both">
                  <div
                    style="display: inline-block;width: 14px;height: 14px;background: #36475a;border-radius: 50%;text-align: center;">
                  </div>
                </div>
              </span>
              <span v-else></span>
            </td>
            <td>
              <span v-if="row.FCI">
                <div class="c-text-both">
                  <div
                    style="display: inline-block;width: 14px;height: 14px;background: #36475a;border-radius: 50%;text-align: center;">
                  </div>
                </div>
              </span>
              <span v-else></span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <img src="@/assets/images/productsPage/BigPicture.jpg" alt="" style="    max-height: 100%; width: 100%;">

    <div id="product-add-ons"></div>
    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">发展</span>
      <hr class="divider">
    </div>
    <div class="c-text-between px-container c-flex-wrap">
      <div class="display-width">
        <img src="@/assets/images/productsPage/Franka_Robotics.jpg" alt="" style="    height: auto; max-width: 100%;">
      </div>

      <div class="display-width c-text-column  c-pdr-40" style="align-items: flex-start; justify-content: center;">
        <h1>机器人系统 </h1>

        <span class="c-mt-5 c-mb-10 text-indent" style="text-align: left;">Franka Research 3的机器人系统包括机械臂及其控制箱。
          这款灵敏且高效的机械臂具备7个自由度，每个关节均配有力矩传感器，具有工业级精度的位姿重复精度（±0.1 mm），即使在高速运动下路径偏差也几乎可以忽略不计。该机械臂的有效载荷为3 kg，工作范围达到855
          mm，覆盖率高达94.5%。</span>
        <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10">
          <div class="buttonSite">
            <!-- documents -->
            <!-- <a href="/#/resources" target="_blank">获取资料</a> -->
            <a href="/#/documents" target="_blank">获取资料</a>
          </div>
        </div>
        <h1 class="c-text-left">Franka控制接口（FCI）</h1>

        <span class="c-mt-5 c-mb-10 text-indent" style="text-align: left;">FCI是一款强大的控制接口，适用于探索底层编程与控制方案。它以1
          kHz的频率提供机器人的实时状态，并支持直接力矩控制。
          除了C++接口库libfranka，FCI还可集成主流生态系统，包括ROS、ROS 2以及MATLAB & Simulink！ </span>
        <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10">
          <div class="buttonSite">
            <!-- <a href="http://10.15.1.204:9002/">文档</a> -->
            <a href="https://frankaemika.github.io/docs/">文档</a>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="c-text-column c-text-both action-height px-container" 
            style="align-items: flex-start; justify-content: center;">
            <h2 class="c-zIndex-2">对我们的产品感兴趣吗？</h2>
            <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10 c-zIndex-2"> 
                  <router-link to="/contact" class="buttonSite">联系我们</router-link> 
            </div>
            <div style="position: absolute;right: 0;height: 100%;"> 
              <img src="@/assets/images/productsPage/FR3 move new 6.png" alt=""
              style="    height: 100%; max-width: 100%;">
            </div> 
        </div> -->

  </div>
</template>

<script>

import backgroundImage from "@/assets/images/productsPage/FR3 move new 6.png";
export default {
  metaInfo() {
    return {
      title: this.$route.meta.title, // 从路由获取标题
      meta: [
        {
          name: 'keywords',
          content: this.$route.meta.metaTags[0]['content']
        }
      ]
    }
  },
  name: 'HomePage',
  data() {
    return {
      iframeValue: false,
      activeIndex: 0,
      carouselInterval: null,
      isTransitioning: false,
      images: [
        { src: require('@/assets/images/productsPage/_Frank Robotics4386_resized (1).jpg'), alt: 'Franka Robotics产品图片1' },
        { src: require('@/assets/images/productsPage/_Frank Robotics0265_resized-1.jpg'), alt: 'Franka Robotics产品图片2' },
        { src: require('@/assets/images/productsPage/_Frank Robotics0304 1_resized.jpg'), alt: 'Franka Robotics产品图片3' },
        { src: require('@/assets/images/productsPage/_Frank Robotics0200_resized.jpg'), alt: 'Franka Robotics产品图片4' },
        { src: require('@/assets/images/productsPage/_Frank Robotics0041_resized.jpg'), alt: 'Franka Robotics产品图片5' },
        { src: require('@/assets/images/productsPage/_Frank Robotics0127_resized.jpg'), alt: 'Franka Robotics产品图片6' },
        { src: require('@/assets/images/productsPage/_Frank Robotics0155_resized.jpg'), alt: 'Franka Robotics产品图片7' }
      ],
      iframe1: '2',
      iframe2: '2',
      backgroundImage: backgroundImage,
      tableData: [
        { name: '基于工作流的应用程序编程', DESK: true, RIDE: false, FCI: false },
        { name: '快速原型设计实验和演示 ', DESK: true, RIDE: false, FCI: false },
        { name: '执行机器人任务', DESK: true, RIDE: false, FCI: true },
        { name: '开发自定义应用程序', DESK: false, RIDE: true, FCI: false },
        { name: '连接第三方硬件', DESK: false, RIDE: true, FCI: true },
        { name: '连接外部资源', DESK: false, RIDE: true, FCI: true },
        { name: '1 kHz 力矩、位置和速度控制 ', DESK: false, RIDE: false, FCI: true },
        { name: '1 kHz 传感器信号和机器人状态的测量', DESK: false, RIDE: false, FCI: true },
        { name: '访问机器人运动学和动力学模型', DESK: false, RIDE: false, FCI: true },
        { name: '与ROS和MATLAB & Simulink的集成', DESK: false, RIDE: false, FCI: true },
      ]
    }

  },
  mounted() {
    this.startCarousel();
  },
  beforeUnmount() {
    clearInterval(this.carouselInterval);
  },
  methods: {
    startCarousel() {
      this.carouselInterval = setInterval(() => {
        this.nextSlide();
      }, 5000);
    },
    nextSlide() {
      if (this.isTransitioning) return;
      this.isTransitioning = true;

      this.activeIndex = (this.activeIndex + 1) % this.images.length;

      setTimeout(() => {
        this.isTransitioning = false;
      }, 500); // 与过渡时间保持一致
    },
    prevSlide() {
      if (this.isTransitioning) return;
      this.isTransitioning = true;

      this.activeIndex = (this.activeIndex - 1 + this.images.length) % this.images.length;

      setTimeout(() => {
        this.isTransitioning = false;
      }, 500);
    },
    goToSlide(index) {
      if (this.isTransitioning || index === this.activeIndex) return;
      this.isTransitioning = true;

      this.activeIndex = index;

      setTimeout(() => {
        this.isTransitioning = false;
      }, 500);
    },
    pauseCarousel() {
      clearInterval(this.carouselInterval);
    },
    resumeCarousel() {
      this.startCarousel();
    }
  }
};
</script>
<style scoped>
.newBack:hover {
  background-color: white;
  color: black;
}

/* 新增轮播图样式 - 水平滑动效果 */
.carousel-container {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.carousel {
  position: relative;
  width: 100%;
  height: 100%;
}

.slides-wrapper {
  display: flex;
  height: 100%;
  transition: transform 0.5s ease;
  will-change: transform;
}

.slide {
  flex: 0 0 100%;
  min-width: 100%;
  position: relative;
}

.carousel-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.carousel-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  background: rgba(0, 0, 0, 0);
  color: white;
  border: none;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s ease;
}

.carousel-btn:hover {
  /* background: rgba(0,0,0,0.8); */
}

.carousel-btn.prev {
  left: 15px;
}

.carousel-btn.next {
  right: 15px;
}

.carousel-indicators {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  z-index: 10;
}

.carousel-indicators span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: background 0.3s ease;
}

.carousel-indicators span.active {
  background: white;
}

li::marker {
  unicode-bidi: isolate;
  font-variant-numeric: tabular-nums;
  text-transform: none;
  text-indent: 0px !important;
  text-align: start !important;
  text-align-last: start !important;
}

.flex-width {
  width: calc(100% / 6);
}

@media (max-width: 1260px) {
  .flex-width {
    width: calc(100% / 4);
  }
}

@media (max-width: 999px) {
  .flex-width {
    width: calc(100% / 3);
  }
}

@media (max-width: 747px) {
  .flex-width {
    width: calc(100% / 2);
  }
}

@media (max-width: 150px) {
  .flex-width {
    width: 100%
  }
}

.title-width {
  width: 33.33%;
}

/* 屏幕宽度小于 900px 时，一行展示 2 个 */
@media (max-width: 899px) {
  .title-width {
    width: 100%
  }
}

.action-height {
  height: 400px;
  background-color: #d5dbdc;
  position: relative;
}

.action-width {
  width: calc(33% - 40px);
}

/* 屏幕宽度小于 900px 时，一行展示 2 个 */
@media (max-width: 1029px) {
  .action-width {
    width: calc(50% - 40px);
  }

  .action-height {
    height: 200px;
    background-color: #d5dbdc;
  }
}

/* 屏幕宽度小于 600px 时，一行展示 1 个 */
@media (max-width: 599px) {
  .action-width {
    width: 100%;
  }
}

table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  border: 1px solid black;
  padding: 5px;
  text-align: left;
}
</style>